module.exports = __webpack_public_path__ + "img/place-holder-avatar.ef0dd45f.jpg";